import { usePublishEvent } from '@agilelab/plugin-wb-events';
import { ConfirmDialog, DialogOnClose } from '../ConfirmDialog';
import { userSignedOutTopic } from '@agilelab/plugin-wb-events-common';
import {
  configApiRef,
  errorApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { authExtensionApiRef } from '@agilelab/plugin-wb-auth-extension-common';

export interface WbLogoutConfirmDialogProps {
  open: boolean;
  onClose: DialogOnClose;
}
export const WbLogoutConfirmDialog = (props: WbLogoutConfirmDialogProps) => {
  const { onClose, ...dialogProps } = props;
  const config = useApi(configApiRef);
  const authExtensionApi = useApi(authExtensionApiRef);
  const identityApi = useApi(identityApiRef);
  const errorApi = useApi(errorApiRef);

  const shouldInvalidateTokensOnLogout = config.getOptionalBoolean(
    'auth.tokenInvalidation.invalidateOnLogout',
  );
  const { publish } = usePublishEvent({ generatorSystem: 'settings' });

  // before logout invalidate token and wait, it is a critical operation
  const onConfirm = async () => {
    await Promise.allSettled([
      publish(userSignedOutTopic, {}),
      shouldInvalidateTokensOnLogout
        ? authExtensionApi.invalidateUserTokens({})
        : Promise.resolve(),
    ]);

    identityApi.signOut().catch(error => errorApi.post(error));
  };

  return (
    <ConfirmDialog
      title="Confirm Log out"
      description="Are you sure you want to log out?"
      confirmText="Log out"
      confirmButtonText="Log out"
      confirmColor="secondary"
      onClose={onClose}
      onConfirm={onConfirm}
      {...dialogProps}
    />
  );
};
